module.exports = __webpack_public_path__ + "static/media/pretzels.05d46f3f.png";